// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3n6R4","balanceDisclaimer":"posDashboard_balanceDisclaimer__3Zwr4"};